import { $api } from '@service/RequestService';
import { useQuery } from 'react-query';

import { crmConstants, crmModels } from '..';

export const usePipeTemplateAll = () =>
  useQuery<crmModels.IPipeTemplate[]>({
    queryKey: [crmConstants.queryKeys.PIPE_TEMPLATE_ALL],
    queryFn: async () => {
      const res = await $api.get('/v1/pipe/template/all');

      return res?.data?.data;
    }
  });
